var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_33506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 47.771C31.3354 47.771 34.5934 47.0762 36.6389 48.5763L40.693 51.5445C42.2001 52.6489 43.8314 52.2853 45.5133 52.023C47.7267 51.6756 49.7078 53.5646 49.7078 56.0219C49.7078 56.6938 44.9381 58.4033 44.2501 58.7278C43.5877 59.041 42.8524 59.1675 42.1234 59.0937C41.3944 59.0199 40.6994 58.7486 40.1132 58.309L35.5391 54.9566",
    stroke: "#004276",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7078 54.513L59.1206 50.1643C59.9508 49.8775 60.8461 49.8368 61.6989 50.047C62.5516 50.2572 63.3255 50.7095 63.9271 51.3493L65.4687 52.9622C66.0209 53.5374 65.8921 54.5084 65.2087 54.9041L47.1377 65.3984C46.6039 65.7113 46.0113 65.9109 45.397 65.9849C44.7827 66.0589 44.1597 66.0057 43.5668 65.8286L29 61.4777M47.4115 43.0087C47.4115 43.0087 52.2434 37.857 52.2434 31.5043C52.2434 25.1516 47.4115 20 47.4115 20C47.4115 20 42.5797 25.1516 42.5797 31.5043C42.5797 37.857 47.4115 43.0087 47.4115 43.0087ZM42 30.5C38.5 28 31.3055 26.5736 31.3055 26.5736C31.3055 26.5736 31.4596 33.7753 35.9072 38.3149C40.3548 42.8522 47.4115 43.0087 47.4115 43.0087C47.4115 43.0087 54.4683 42.8522 58.9159 38.3149C63.3634 33.7753 63.5176 26.5736 63.5176 26.5736C63.5176 26.5736 57.5 26.5 53 31",
    stroke: "#004276",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_33506",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_33506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_33506",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadericon);
export default __webpack_public_path__ + "static/media/header icon.dd488cdfd46db79272f0509be289a52a.svg";
export { ForwardRef as ReactComponent };